<div class="w-100">
  <!-- Settings Header -->
  <div class="section-header">
    <mat-icon>tune</mat-icon>
    <span>{{ "generic.settings" | translate }}</span>
  </div>

  <!-- Use Slider -->
  <div class="d-flex justify-content-between align-items-center py-2">
    <span>{{ "modals.modal-survey-details.use-slider" | translate }}</span>
    <mat-slide-toggle color="primary" [disabled]="!editable" [(ngModel)]="getCustoms.use_slider" [ngModelOptions]="{standalone: true}"
      name="consensus_use_slider"></mat-slide-toggle>
  </div>

  @if (getCustoms.use_slider) {
    <!-- Tricolor -->
    <div class="d-flex justify-content-between align-items-center py-1">
      <span>Create three colored sections (green, yellow, red) in the slider indicating value ranges.</span>
      <mat-slide-toggle color="primary" [disabled]="!editable" [(ngModel)]="getCustoms.tricolor" [ngModelOptions]="{standalone: true}"
        name="consensus_tricolor"></mat-slide-toggle>
    </div>
    <!-- Step -->
    <div class="step-row">
      <span class="step-label">{{ "generic.step-value" | translate | titlecase }}</span>
      <mat-form-field appearance="fill" class="step-input" subscriptSizing="dynamic">
        <input [disabled]="!editable" type="number" required matInput [(ngModel)]="getCustoms.step" [ngModelOptions]="{standalone: true}"
          name="consensus_step">
      </mat-form-field>
    </div>
    <!-- Custom Labels -->
    <div class="d-flex justify-content-between align-items-center py-1">
      <span>{{ "generic.customs-min-max-labels" | translate }}</span>
      <mat-slide-toggle color="primary" [disabled]="!editable" [(ngModel)]="getCustoms.use_custom_min_max_labels" [ngModelOptions]="{standalone: true}"
        name="consensus_custom_labels"></mat-slide-toggle>
    </div>
    <!-- Custom Labels Inputs -->
    @if (getCustoms.use_custom_min_max_labels) {
      <div class="custom-labels-inputs">
        <mat-form-field appearance="fill" class="flex-1 pb-0">
          <mat-label>{{ "generic.min" | translate }}</mat-label>
          <input [disabled]="!editable" required matInput [(ngModel)]="getCustoms.min_label" [ngModelOptions]="{standalone: true}"
            name="consensus_min_label">
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-1 pb-0">
          <mat-label>{{ "generic.max" | translate }}</mat-label>
          <input [disabled]="!editable" required matInput [(ngModel)]="getCustoms.max_label" [ngModelOptions]="{standalone: true}"
            name="consensus_max_label">
        </mat-form-field>
      </div>
    }
    <!-- Preview -->
    <div class="preview-section">
      <div class="section-header">
        <mat-icon>visibility</mat-icon>
        <span>{{ "generic.preview" | translate }}</span>
      </div>
      <div class="preview-content">
        @if (!isResponse) {
          <div class="slider-preview-wrapper" [class.tricolor]="getCustoms?.tricolor">
            <mat-slider class="w-100 cdk-focused" [discrete]="true" color="primary" [disabled]="!editable">
              <input matSliderThumb [max]="100" [min]="0" [step]="getCustoms?.step || 1">
            </mat-slider>
          </div>
        }
        <div class="preview-labels">
          @if (!getCustoms.use_custom_min_max_labels) {
            <small>{{ 'components.responses.absolutely-not-sure' | translate }}</small>
            <small>{{ 'components.responses.absolutely-sure' | translate }}</small>
          } @else {
            <small>{{ getCustoms.min_label }}</small>
            <small>{{ getCustoms.max_label }}</small>
          }
        </div>
      </div>
    </div>
  }
</div>
